import { ToastContainer } from "react-toastify";
import { useEffect, useState } from "react";
import {
  getArrayListener,
  handlePlayerRetrival,
  incrementPlayerField,
  resetAddedQuota,
} from "./firebase/fireFuncs";
import Player from "./player/Player";
import MainStore from "./stores/MainStore";
import { useSprings, animated } from "react-spring";
import ActiveGoal from "./active/ActiveGoal";
import ActiveBox from "./active/ActiveBox";
import ShowButton from "./active/ShowButton";
import DragCursor from "./DropAreas/DragCursor";
import DropAreas from "./DropAreas/DropAreas";
import useTimer from "./hooks/useTimer";
import DisplayedBoxes from "./box/DisplayedBoxes";
import ActiveFocus from "./focus/ActiveFocus";
import ThoughtsButton from "./thoughts/ThoughtsButton";
import LookUpInput from "./lookUp/LookUpInput";
import useSizePercentage from "./hooks/useSizePercentage";
import lookupStore from "./stores/lookupStore";
import { DisplayedOptions } from "./displayedOptions/DisplayedOptions";
import Create from "./create/Create";
import { addObjectsToPlayer, uploadGoalToBoxes } from "./misc/fixingStuff";
import { addToTimesPlayed, updateOpenObjects } from "./firebase/playerFuncs";
import ResultButtons from "./stores/ResultButtons";
import collectionStore from "./stores/collectionStore";
import DetailedView from "./detailedView/DetailedView";
import activeStore from "./stores/activeStore";
import useHandleActiveGoal from "./hooks/useHandleActiveGoal";
import useObjectSorting from "./objectSorting/useObjectSorting";
import useHandleBoxes from "./handleBoxes/useHandleBoxes";
import {
  forArrayLength,
  getBoxTypeNames,
  objectToArray,
} from "./misc/helperfuncs";
import { queryRelatedTypes } from "./firebase/fireQueries";
import boxStore from "./stores/boxStore";
import BoxTypeOverview from "./boxTypeOverview/BoxTypeOverview";
import useHandleListeners from "./hooks/useHandleListeners";
import useHandleActiveBox from "./hooks/useHandleActiveBox";
import useHandleRealTimeDB from "./hooks/useHandleRealTimeDB";
import LoadingScreen from "./misc/elements/LoadingScreen";
import PointCursor from "./cursors/PointCursor";

function App() {
  const {
    player,
    setPlayer,
    setVerifiedId,
    dragCursor,
    create,
    setCreate,
    setFirstLoad,
  } = MainStore();
  const { detailedView, setTick, firstLoad } = MainStore();
  const { setAllActive } = activeStore();
  const { foundStuff } = lookupStore();
  const objectSorting = useObjectSorting();
  const { setGeneralObjects } = collectionStore();
  const [showActiveBox, setShowActiveBox] = useState(false);
  const [timePassed, setTimePassed] = useState(false);
  const [showEnterDetails, setShowEnterDetails] = useState(false);
  const [showPlayer, setShowPlayer] = useState(true);
  const [showActiveGoal, setShowActiveGoal] = useState(false);
  const [createInputs, setCreateInputs] = useState([]);
  const timer = useTimer();
  const [createString, setCreateString] = useState("Create");
  const sizePercentage = useSizePercentage();
  const handleBoxes = useHandleBoxes();
  const { setRelatedBoxTypes, boxTypeOverview } = boxStore();
  const handleListeners = useHandleListeners();
  const handleActiveBox = useHandleActiveBox();
  const handleActiveGoal = useHandleActiveGoal();
  useHandleRealTimeDB();
  function onRelatedDocsReceived(list) {
    setRelatedBoxTypes(list);
  }

  function handleEscape(e) {
    console.log("e.key - ", e.key, " | e.code - ", e.code);
  }

  useEffect(() => {
    document.addEventListener("keydown", handleEscape);
    return () => {
      window.removeEventListener("keydown", handleEscape);
    };
  }, []);

  function getRelatedBoxTypes(boxTypes) {
    const relatedPluralNames = [];
    forArrayLength(objectToArray(boxTypes, "name", "value"), (kv) => {
      forArrayLength(kv.value.related.types, (relatedType) => {
        relatedPluralNames.push(relatedType);
      });
    });
    if (relatedPluralNames.length > 0)
      queryRelatedTypes(relatedPluralNames, onRelatedDocsReceived);
  }

  useEffect(() => {
    if (firstLoad) {
      getRelatedBoxTypes(player.boxTypes);
    }
  }, [firstLoad]);

  useEffect(() => {
    if (timer.tick % 60 == 0 && timer.tick != 0) {
      incrementPlayerField(player.uid, "minutesPlayed", 1);
      resetAddedQuota(player);
    }
    setTick(timer.tick);
  }, [timer.tick]);

  useEffect(() => {
    if (player) {
      setFirstLoad(true);
    }
  }, [player]);

  useEffect(() => {
    handlePlayerRetrival(
      setPlayer,
      setVerifiedId,
      getArrayListener,
      handleListeners.onArrayFound,
      setAllActive
    );
  }, []);

  useEffect(() => {
    const general = JSON.parse(localStorage.getItem("general"));
    console.log("general - ", general);
    setGeneralObjects(general);
    setTimeout(() => {
      setTimePassed(true);
    }, 5000);
  }, []);

  return (
    <div
      style={{
        width: "100%",
        height: "100vh",
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
      }}
    >
      {player && (
        <div
          className="App"
          style={{
            width: "100%",
            height: "100vh",
            display: "flex",
            flexDirection: "row",
          }}
        >
          <DragCursor />
          <PointCursor />
          {dragCursor && (
            <DropAreas
              setShowActiveGoal={setShowActiveGoal}
              setShowActiveActivity={setShowActiveBox}
            />
          )}
          {!dragCursor && (
            <div
              style={{
                width: "100%",
                height: "100vh",
                display: "flex",
                flexDirection: "row",
              }}
            >
              {!showActiveBox && (
                <ShowButton
                  color="brown"
                  positionBottom={"50%"}
                  positionLeft={`${(5 / 100) * sizePercentage.width}%`}
                  description={"Active Box"}
                  onClick={setShowActiveBox}
                  show={true}
                />
              )}
              {!showActiveGoal && (
                <ShowButton
                  color="blue"
                  positionTop={"5%"}
                  positionRight="50%"
                  description={"Active Goal"}
                  show={true}
                  fontColor="#0f0f0f"
                  onClick={setShowActiveGoal}
                />
              )}
              {!showPlayer && (
                <ShowButton
                  color="green"
                  description={"Show Player"}
                  onClick={setShowPlayer}
                  positionRight="5%"
                  positionBottom={"50%"}
                  show={true}
                />
              )}
              {showActiveGoal && !showEnterDetails && (
                <animated.div>
                  <ActiveGoal
                    setShowActiveGoal={setShowActiveGoal}
                    handleActive={handleActiveGoal}
                  />
                </animated.div>
              )}

              {showActiveBox && !showEnterDetails && (
                <animated.div style={{ position: "relative" }}>
                  <ActiveBox
                    setShowActiveBox={setShowActiveBox}
                    handleActiveBox={handleActiveBox}
                  />
                </animated.div>
              )}
              {!showEnterDetails && (
                <animated.div
                  className={"divRow"}
                  style={{
                    position: "absolute",
                    top: "0%",
                    left: "5%",
                    marginTop: "20px",
                  }}
                >
                  <ActiveFocus />
                  <ThoughtsButton />
                </animated.div>
              )}
              {!showEnterDetails && (
                <animated.div
                  style={{
                    display: "flex",
                  }}
                >
                  <animated.div
                    className={"divColumn"}
                    style={{
                      alignItems: "start",
                      justifyContent: "center",
                      display: "flex",
                      marginLeft: `${(300 / 100) * sizePercentage.width}px`,
                      marginTop:
                        sizePercentage.height < 85
                          ? "50px"
                          : sizePercentage.height < 75
                          ? sizePercentage.height < 50
                            ? "200"
                            : "80px"
                          : "0px",
                    }}
                  >
                    {detailedView && boxTypeOverview.length == 0 && (
                      <DetailedView
                        sizePercentage={sizePercentage}
                        handleActiveGoal={handleActiveGoal}
                        handleActiveBox={handleActiveBox}
                      />
                    )}
                    {boxTypeOverview.length > 0 && <BoxTypeOverview />}
                    {!create &&
                      !detailedView &&
                      !handleBoxes.areaOpen &&
                      boxTypeOverview.length == 0 && (
                        <div
                          className="divColumn"
                          style={{
                            minHeight: "300px",
                            width: `${(1700 / 100) * sizePercentage.width}px`,
                          }}
                        >
                          <LookUpInput />
                          <DisplayedOptions />
                          {foundStuff && <ResultButtons />}
                          <DisplayedBoxes />
                        </div>
                      )}
                    {handleBoxes.areaOpen && handleBoxes.divs}
                    {create && (
                      <Create
                        action={createString}
                        width={`${(1500 / 100) * sizePercentage.width}px`}
                        height={"60%"}
                        create={create}
                        setCreate={setCreate}
                        player={player}
                        marginLeft="10%"
                      />
                    )}
                  </animated.div>
                </animated.div>
              )}

              {showPlayer && (
                <animated.div>
                  <Player
                    closeBoxTypeArea={handleBoxes.closeArea}
                    setActiveMood={handleActiveGoal.setActiveMood}
                    openArea={handleBoxes.openArea}
                    areaOpen={handleBoxes.areaOpen}
                  />
                </animated.div>
              )}
              {showPlayer && (
                <ShowButton
                  positionBottom={"5%"}
                  positionRight="2%"
                  color="green"
                  description={"Hide Player"}
                  show={false}
                  onClick={setShowPlayer}
                />
              )}
            </div>
          )}
          <ToastContainer
            position="bottom-left"
            autoClose={2000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
          />
        </div>
      )}
      {!player && <LoadingScreen />}
    </div>
  );
}

export default App;
